export default function addAnimationClass(container, delay) {
    let elemContainer = container,
        elems = Array.from(elemContainer.querySelectorAll('.to-animate'));
        if (elems.length > 0) {
        let loop = setInterval(() => {
            elems[0].classList.add('anime');
            elems.shift();
            if (elems.length <= 0) {
                clearInterval(loop)
            }
        }, delay);
    }

};


// WEBPACK FOOTER //
// ./src/shared/helpers/addAnimationClass.js